/**
 * Logging utility stub
 * Stub implementation – replace with a real logging library (e.g. New Relic, Datadog) when available.
 */

export const logger = {
  info: (message: string, ...args: unknown[]) => {
    console.log(`[INFO] ${message}`, ...args);
  },
  error: (message: string, ...args: unknown[]) => {
    console.error(`[ERROR] ${message}`, ...args);
  },
  warn: (message: string, ...args: unknown[]) => {
    console.warn(`[WARN] ${message}`, ...args);
  },
  debug: (message: string, ...args: unknown[]) => {
    console.debug(`[DEBUG] ${message}`, ...args);
  },
};

/**
 * Log error to New Relic (stub implementation)
 * Replace with actual New Relic integration when available.
 */
export const logErrorToNewRelic = (error: unknown, context?: Record<string, unknown>) => {
  console.error("[New Relic Error]", error, context);
};

/**
 * Log custom attribute to New Relic (stub implementation)
 * Replace with actual New Relic integration when available.
 */
export const logCustomAttributeToNewRelic = (key: string, value: unknown) => {
  console.log("[New Relic Attribute]", key, value);
};

export default logger;
